import axios from "axios";
export const localserver = process.env.REACT_APP_API_URL;
export const production = process.env.REACT_APP_ENV;
axios.defaults.baseURL = localserver;
axios.defaults.withCredentials = true;
axios.defaults.headers = {
   
}
export default axios;